/* This renders a full screen card of two newspaper frontpages 
   side by side.

   Hassaan Ali Wattoo 
*/ 

import React from 'react';

class SideBySideCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            leftImage: '',
            rightImage: '',
        }
    }

    render() {
        return (
            <div className="side-by-side-container row">
                <div className="side-image left six columns">
                    <img 
                    src={`${process.env.PUBLIC_URL}/images/side-left.jpg`}
                    alt="Michigan Daily Front Page for 950 Wins Edition" />
                </div>
                <div className="side-image right six columns">
                    <img 
                    src={`${process.env.PUBLIC_URL}/images/side-right.png`}
                    alt="Michigan Daily Front Page for 2011 win over Ohio State" />
                </div>
            </div>
        );
    }
        
    
}

export default SideBySideCard;